"use client";

import Heading from "@afa-shared/afa-components/dist/Heading";
import Text from "@afa-shared/afa-components/dist/Text";
import Grid from "@components/client/Grid";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { Suspense } from "react";

import insuranceSearchStyles from "./InsuranceSearch.module.css";
import InsuranceSearchContentWrapper from "./client/InsuranceSearchContentWrapper";
import Results from "./client/Results";
import SearchInput from "./client/SearchInput";

interface IInsuranceHandbookSearchPage {
  inheritedContentArea?: any;
  leftMenuItems?: any;
  factItems?: any;
}

const InsuranceHandbookSearchPage = ({
  inheritedContentArea,
  leftMenuItems,
  factItems,
}: IInsuranceHandbookSearchPage) => {
  return (
    <NuqsAdapter>
      <InsuranceSearchContentWrapper
        leftMenuItems={leftMenuItems}
        inheritedContentArea={inheritedContentArea}
      >
        <Grid container>
          <Heading variant="h1">Sök i Försäkringshandboken</Heading>
          <Text
            variant={"preamble"}
            children={
              "Informationen riktar sig till dig som är försäkringsinformatör eller representant för arbetsgivare och fack inom kommun eller region."
            }
          />

          <Grid
            container
            direction="row"
            justifyContent="center"
            className={insuranceSearchStyles.formWrapper}
            role="search"
          >
            <Suspense fallback={null}>
              <SearchInput />
            </Suspense>
          </Grid>
          <div className={insuranceSearchStyles.resultWrapper} tabIndex={-1} data-temp-keep-index>
            <Suspense fallback={null}>
              <Results factItems={factItems} />
            </Suspense>
          </div>
        </Grid>
      </InsuranceSearchContentWrapper>
    </NuqsAdapter>
  );
};

export default InsuranceHandbookSearchPage;
